import { Outlet, useLocation } from 'react-router';
import { ErrorBoundary } from '@/components/feedback/ErrorBoundary';
import { AppHeader } from './AppHeader';

export function AppLayout() {
  const { pathname } = useLocation();
  return (
    <div className="min-h-screen bg-slate-100 text-slate-800 font-sans antialiased pb-12">
      <AppHeader />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6 space-y-6">
        {/* Keyed by route so navigating away from a crashed page recovers. */}
        <ErrorBoundary key={pathname}>
          <Outlet />
        </ErrorBoundary>
      </main>
    </div>
  );
}
